import React from 'react';

interface PortalNavigationProps {
  userRole: string;
  onNavigate: (portal: string) => void;
  currentPortal?: string;
}

export function PortalNavigation({ userRole, onNavigate, currentPortal }: PortalNavigationProps) {
  const portals = [
    {
      id: 'home',
      label: 'Home',
      icon: '🏠',
      roles: ['MANAGER', 'CASHIER', 'PRODUCTION'],
    },
    {
      id: 'till',
      label: 'Till',
      icon: '💳',
      roles: ['CASHIER', 'PRODUCTION'],
    },
    // 'manager' portal intentionally omitted: it duplicated the manager
    // dashboard that Home already shows, and its staff/reports/settings
    // tabs were non-functional stubs. Kept in the repo pending a decision.
    {
      id: 'admin',
      label: 'Admin Portal',
      icon: '⚙️',
      roles: ['MANAGER'],
    },
    {
      id: 'staff',
      label: 'Staff App',
      icon: '👤',
      roles: ['MANAGER', 'CASHIER', 'PRODUCTION'],
    },
  ];

  const availablePortals = portals.filter((p) => p.roles.includes(userRole));

  return (
    <div className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex gap-2 overflow-x-auto">
          {availablePortals.map((portal) => (
            <button
              key={portal.id}
              onClick={() => onNavigate(portal.id)}
              className={`whitespace-nowrap px-4 py-2 rounded-lg font-medium transition-colors ${
                currentPortal === portal.id
                  ? 'bg-amber-100 text-amber-800'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              {portal.icon} {portal.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
